import React, { useState } from "react";
import * as FeatherIcon from "react-feather";
import IOSSpinner from "../../../../../HtmlElements/IOSSpinner";

export default function ContactDeleteCell({ id, name, nonEditable, handleDelete }) {
  const [isDeleting, setIsDeleting] = useState(false);

  const onDelete = async () => {
    try {
      setIsDeleting(true);
      await handleDelete(id); // call the parent’s delete handler
    } finally {
      setIsDeleting(false);
    }
  };

  if (nonEditable) return null;

  return (
    <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
      {isDeleting ? (
        <IOSSpinner size={10} />
       // show spinner while deleting
      ) : (
        <FeatherIcon.Trash2
          className="sct-delete-btn"
          onClick={onDelete}
          aria-label={`Remove ${name || "contact"} from selection`}
          title="Remove from selected"
        />
      )}
    </div>
  );
}
